
$(function () {

  // Podmiany aria-hidden w nagłówkach
  if ($('[data-title-desktop-hidden]').length > 0 && $(window).width() < 768) {
    $('[data-title-desktop-hidden]').attr('aria-hidden', 'false');
    $('[data-title-mobile-hidden]').attr('aria-hidden', 'true');
  }

  // scroll spisu treści w artykułach
  if ($("[data-dynamic-list]").length > 0) {
    scrollDynamicList(80);
  }
  function scrollDynamicList($top) {
     $("[data-dynamic-list] a").click(function (e) {
      e.preventDefault();
      let itemId = $(this).attr("href");
      $("html, body").animate(
          {
            scrollTop: $(itemId).offset().top - $top,
          },
          300
      );
    });
  }
  //dynamiczne style podpisu zdjec w artykule z acms
  if ($(".article__entry p a img").length > 0) {
    $('.article__entry p a img').each(function() {
      // $(this).parent().parent().find('em').addClass('articleImgCaption inside');
      // $(this).parent().parent().next('p').addClass('articleImgCaption');
      $(this).parent().parent().find('em').addClass('articleImgCaption inside');
      $(this).parent().parent().next('p').find('em').addClass('articleImgCaption');
      $(this).parent().parent().addClass('articleImgCaption withoutTags');
    });
  }
  //Dynamiczne wysokości listy i mapy w go map 
  if ($("[data-go-map-places]").length > 0) {
    // css dynamic list and map height adjust
    let mapTitle = document.querySelector("[data-gomap-title-height]");
    let mapTitleHeight = mapTitle.offsetHeight;
    $(".wrapperMapList").css({
      height: "calc(100% - " + mapTitleHeight + "px)",
    });
    if ($(window).width() < 768) {
      $(".wrapperGoogleMap").css({
        top: mapTitleHeight + "px",
      });
    }
  }
  // Wyliczanie wysokosci boxScroll w mapach z go
  // if ($("[data-go-map-places]").length > 0) {
  // const listH = $("[data-go-map-places]").find(".wrapperMapList").height();
  // const listTitleH = $("[data-go-map-places-title]").outerHeight();
  //
  // $("[data-go-map-places-boxscroll]").css("height", listH - listTitleH);
  // }

  // White spaces
  if ($(".article__entry p").length > 0) {
    removeWhiteSpaces($(".article__entry p"));
  }
  // Remove white space function - z other.js - TODO
  function removeWhiteSpaces($obj) {
    $obj
        .filter(function () {
          return this.innerHTML.replace("&nbsp;", " ").trim() == "";
        })
        .remove();
  }

  // Pokazywanie i ukrywanie głównej treści artykułu
  if ($("[data-text-read-more-area]").length > 0) {
    const textArea = $("[data-text-read-more-area]");
    let textAreaHeight = textArea.height();
    textArea.css({
      height: "200px",
      overflow: "hidden",
    });

    $("[data-text-read-more-button]").click(function () {
      const button = $(this).parent();
      button.toggleClass("expanded");

      if (button.hasClass("expanded")) {
        textArea.animate(
            {
              height: textAreaHeight,
              overflow: "visible",
            },
            500,
            function () {
              textArea.css({
                height: "auto",
              });
            }
        );
      } else {
        textArea.animate({
          height: "200px",
          minHeight: "200px",
          overflow: "hidden",
        });
        $("html, body").animate(
            {
              scrollTop: textArea.offset().top - 80,
            },
            300
        );
      }

      var buttonText = button.hasClass("expanded") ? "Ukryj" : "Czytaj więcej";
      $(this).children().text(buttonText);
    });
  }

  //acordion show hide text
  if ($(".acordion").length > 0) {
    // działanie zwijanie i rozwijanie
    $("[data-toggle-acordion-text]").on("click", function () {
      // console.log("test");

      let acordionClickedItem = $(this).parent();
      let acordionText = acordionClickedItem.find("[data-acordion-text]");
      let acordionIcon = acordionClickedItem.find("[data-acordion-icon]");

      if (acordionText.hasClass("alreadyVisible")) {
        $(acordionText).stop().slideUp("slow");
        acordionText.removeClass("alreadyVisible");
        acordionIcon.removeClass("active");
        return;
      }
      $(acordionText).stop().slideDown("slow");
      acordionIcon.addClass("active");
      acordionText.addClass("alreadyVisible");
    });
  }

  // Social
  if ($("[data-box-share]").length > 0) {
    $("[data-box-share]").jsSocials({
      showCount: false,
      showLabel: true,
      shares: [
        { share: "facebook", label: "Udostępnij", logo: "icon-fb" },
        { share: "twitter", label: "Udostepnij", logo: "icon-twiter" },
        { share: "linkedin", label: "Udostepnij", logo: "icon-linkedin" },
      ],
    });

    //ukrywamy sociale jak nie ma leada
    if ($("[data-lead]").length === 0) {
      $("[data-box-share]").hide();
    }
  }

  // Sprawdzenie czy fixować sociale (jeżeli nie ma templatek między główną treścią)
  function stickySocial() {
    var isSticky = false;
    // var isSticky = true;
    // if ($('[data-template]').length > 0) {
    // $('[data-template]').each(function() {
    // if ($(this).outerWidth() > $('[data-sticky-container] .article__entry').outerWidth()) {
    // isSticky = false;
    // }
    // });
    // }
    return isSticky;
  }

  // Sticky social bar
  // if (stickySocial() && $('[data-social-bar]').length > 0) {
  // let mainHeaderHeight = $('[data-main-header]').height();
  // let socialBar = $('[data-social-bar]');
  // let articlesRelated = $('[data-related-articles-bottom]');
  // let socialTop = null;
  // let articlesTop = null;
  // let articlesTopCorr = null;
  // //ewentualnie mozna elemTop pobrac w zdarzaniu scroll ale trzeba ograniczyc pobieranie do czasu nadania klasy sticky
  // window.onload = function() {
  // socialTop = socialBar.offset().top;
  // if ($('[data-related-articles-bottom]').length > 0) {
  // articlesTop = articlesRelated.offset().top;
  // } else {
  // articlesTop = $('.mainFooter').offset().top;
  // }
  // articlesTopCorr = articlesRelated.offset().top - socialBar.height();
  // };
  //
  // $(window).scroll(function() {
  // let docTop = $(window).scrollTop() + mainHeaderHeight;
  //
  //
  // const stickyCondition = $('[data-related-articles-bottom]').length > 0
  // ? docTop > socialTop && docTop < articlesTopCorr
  // :
  // docTop > socialTop;
  //
  // if (stickyCondition) {
  // socialBar
  // .addClass('sticky')
  // .css('left', (($(this).width() - $('.article__entry').outerWidth()) / 2 - 80));
  // } else {
  // socialBar
  // .removeClass('sticky')
  // .css('left', '-75px');
  // }
  // });
  // }

  // Ukrycie sociali kiedy artykuł ma za małą wysokość
  // if ($("[data-social-bar]").length > 0) {
  // const leadHeight = $("[data-lead]").height();
  // const articleHeight = $(".article__entry").height();
  // let templateHeight = 0;
  // const socialHeight = $("[data-social-bar]").height();
  //
  // if ($('[data-template]').length > 0) {
  //
  // $('[data-template]').each(function() {
  // const articleWidth = $(".article__entry").width();
  // if ($(this).outerWidth() > articleWidth) {
  // templateHeight = $(this).height();
  // console.log($(this).find('.container').width(), 'widt')
  // console.log($(this).find('.container--small').width(), 'widt')
  // console.log($(this).find('.container--medium').width(), 'widt')
  // }
  // });
  // }
  // console.log(articleHeight)
  // console.log(templateHeight, 'templateHeight')
  // if (leadHeight + articleHeight + templateHeight < socialHeight) {
  // $("[data-social-bar]").css("display", "none");
  // }
  // }

  // Box go one event refactor code
  if ($(".goOneEvent").length > 0) {
    $(".goEventWrapper").each(function () {
      $(this)
          .removeClass("clearfix")
          .children()
          .not(":first-child")
          .wrapAll('<div class="goEventMainContent" />');
    });
  }

  // Fancybox dla zdjęć które nie są zdjeciami z bb code gallery
  if ($(".article__entry a:not(.bbGallery__lnk)").length > 0) {
    $(".article__entry a:not(.bbGallery__lnk)").each(function() {
      if (
          $(this).hasClass("lnkFancybox") ||
          $(this).attr("data-fancybox-group")
      ) {
        $(this)
            .removeAttr("data-fancybox-group")
            .removeClass("lnkFancybox")
            .attr("data-fancybox", "galeria_artykulowa");
      }
    });
  }

  // Fancybox dla zdjęć z bb code gallery
  if ($('[data-bbgallery-box]').length > 0) {
    const nbOfGalleriesInArticle = $('[data-bbgallery-box]').length;
    //indywidualizacja kontenerów każdej galerii
    $('[data-bbgallery-box]').each(function(i) {
      $(this).attr('id', `bbgallery${i}`);
    });
    for (let i = 0; i < nbOfGalleriesInArticle; i++) {
      let galleryGroupIndex = i;
      $(`#bbgallery${galleryGroupIndex} .lnkFancybox`).each(function () {
        $(this).attr('data-fancybox', `galeria_artykulowa${galleryGroupIndex}`)
      });
    }
  }
  // Table
  if ($(".article__entry table").length > 0) {
    $(".article__entry table").each(function () {
      $(this).addClass("table").wrap("<div class='table-responsive'></div>");
    });
  }

  //slider w galerii w artykule
  if ($(".multiPhotoGallerySlider").length > 0) {
    $(".multiPhotoGallerySlider").each(function () {
          $(this).removeClass("multiPhotoGallery");
          $(this).wrapInner("<div class='splide__track'><div class='splide__list'></div></div>");
        }
    )
    $(".multiPhotoGallerySlider .bbGallery__item").addClass('splide__slide');

  }
  let gornySlider = null;

  if ($("[data-standard-slider]").length > 0) {
    let slideNb = 0;
    $("[data-standard-slider]").each(function (index) {
      slideNb = index;
      $(this).attr("id", `standardSlider-${slideNb}`);
      new Splide(`#standardSlider-${slideNb}`, {
        perPage: 3,
        perMove: 3,
        pagination: false,
        gap: "16px",
        arrows: true,
        interval: 3000,
        padding: {
          right: 80,
        },
        breakpoints: {
          700: {
            perPage: 2,
            perMove: 2,
            padding: {
              right: 80,
            },
          },
          575: {
            perPage: 2,
            perMove: 2,

          },
          450: {
            perPage: 1,
            perMove: 1,
            padding: {
              right: 80,
            },
          },
        },
        i18n: {
          prev: 'Poprzedni slajd',
          next: 'Następny slajd',
        },
      }).mount();
    });
  }

  //without fancybox slider
  if ($("[data-big-image-with-slider-gallery]").length > 0) {
    let slideNb = 0;
    $("[data-big-image-with-slider-gallery]").each(function (index) {
      slideNb = index;
      $(this).attr("id", `bigImageWithSliderGallery-${slideNb}`);
      //individualize big photo
      let bigPhotoBox = $(this).parent().find('.bigPhotoBox');
      bigPhotoBox.attr("id", `bigPhotoBox-${slideNb}`)
      //remove Fancybox mechanizm
     // $(".withoutFancybox .bbGallery__lnk").removeAttr('data-fancybox');
      

      const gornySlider = new Splide(`#bigPhotoBox-${slideNb}`, {
       // start: number = 0,
        type: 'fade',
        rewind: true,
        cover: true,
        drag: false,
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: true,
       // interval: 3000,
      
        classes: {
          prev  : 'splide__arrow--prev bigPhotoBoxs-prev',
          next  : 'splide__arrow--next bigPhotoBox-next',
        },
      
        
      })
      .mount();

      //bigImageWithSliderGallery

      const dolnySlider = new Splide(`#bigImageWithSliderGallery-${slideNb}`, {
        //rewind: true,
       // noDrag: '.splide__track, .splide__slide',
       
        drag: false,
        isNavigation: true,
        perPage: 4,
        perMove: 4,
        pagination: false,
        gap: "16px",
        arrows: true,
        padding: {
          right: 80,
        },
     
        breakpoints: {
          767: {
            perPage: 3,
            perMove: 3,
            arrows: false,
            gap: "10px", 
            padding: {
              right: 80,
            },
          },
          400: {
            perPage: 2,
            perMove: 2,
            arrows: false,
            padding: {
              right: 80,
            },
          },
        },
        i18n: {
          prev: 'Poprzedni slajd',
          next: 'Następny slajd',
        },
      }) 
      
      //gornySlider.go( '>' );
      //gornySlider.go( '<' );

      dolnySlider.sync( gornySlider ).mount();
    
    });
    
    

    //click in small img - show it on big Img
    $(".withoutFancybox .bigPhotoLnk .bbGallery__lnk").click(function (e) {
     // e.preventDefault();
    });
    $(".withoutFancybox .bbGallery__item:not(.bigPhotoLnk) .bbGallery__lnk").click(function (e) {
      e.preventDefault();
    //   //active parent box if many of this type
    //    $('.withoutFancybox').removeClass('active');
    //   $(this).closest('.withoutFancybox').addClass('active');
    //   // copy paths and data
    //   let copySmallImgPath = $(this).attr('data-img-src');
    //   let copySmallImgAuthor = $(this).attr('data-img-author');
    //   //change paths in big img
    //   let bigPhotoLnk = $('.active .bigPhotoLnk .bbGallery__lnk');
    //   bigPhotoLnk.attr('href', copySmallImgPath )
    //   let bigImg = bigPhotoLnk.find('img');
    //   bigImg.attr('src', copySmallImgPath );
    //   let bigSources = bigPhotoLnk.find('source');
    //   bigSources.each(function () {
    //     $(this).attr('srcset', copySmallImgPath );
    //   })
    //   let bigAuthor = bigPhotoLnk.find('[data-big-img-author]');
    //   bigAuthor.text(copySmallImgAuthor); 
    })
  }

  //galeria portalowa
  if ($('[data-gallery-view]').length > 0) {
    let next = $('#next');
    let prev = $('#prev');
    let xFirst = null;
    let yFirst = null;

    let movedImg = document.querySelector('.pictureBox');
    let portalGalleryBox = document.querySelector('.portalGalleryBox');
    portalGalleryBox.addEventListener('touchstart', handleTouchStart, false);
    portalGalleryBox.addEventListener('touchmove', handleTouchMove, false);
    portalGalleryBox.addEventListener('touchend', handleTouchEnd, false);

    function getTouches(e) {
      return e.touches ||
          e.originalEvent.touches;
    }
    function handleTouchStart(e) {
      const firstTouch = getTouches(e)[0];
      xFirst = firstTouch.clientX;
      yFirst = firstTouch.clientY;
    };
    function handleTouchMove(e) {
      let xMove = e.touches[0].clientX;
      let yMove = e.touches[0].clientY;
      let xDiff = xFirst - xMove;
      let yDiff = yFirst - yMove;
      let xLong = xMove - xFirst;
      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) { /*for detecting right left move*/
        // if (xLong > 50 || xLong < -50) {
        if (xLong > 75 || xLong < -75) {
          if (xLong > 80 ) {xLong = 80}
          if (xLong < -80) {xLong = -80}
          if ( xDiff > 0 && next.attr('href')) {
            movedImg.style.transform = `translateX(${xLong}px)`;
          }
          if (xDiff < 0 && prev.attr('href')) {
            movedImg.style.transform = `translateX(${xLong}px)`;
          }
        }
      }
    }
    function handleTouchEnd(e) {
      if ( ! xFirst || ! yFirst ) {
        return;
      }
      let xMove = e.changedTouches[0].clientX;
      let yMove = e.changedTouches[0].clientY;
      let xDiff = xFirst - xMove;
      let yDiff = yFirst - yMove;

      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {/*for detecting right left move*/
        if ( xDiff > 0 && next.attr('href')) {
          window.location.href = next.attr('href');
        }
        if (xDiff < 0 && prev.attr('href')) {
          window.location.href = prev.attr('href');
        }
      }
      /* reset values */
      xFirst = null;
      yFirst = null;
    };

    $(window).keydown(function (e) {
      if(e.keyCode == 37 && prev.attr('href') ) {
        window.location.href = prev.attr('href');
      }
      if(e.keyCode == 39 && next.attr('href')) {
        window.location.href = next.attr('href');
      }
    });

    // window.addEventListener('load', function(){
    // $('.galleryView .photoBox').css({minHeight:'unset'});
    // });
  };


  if ($('.bbGallery .compareGallery').length > 0) {
    $(".twentytwenty-container").twentytwenty({
      before_label: 'Przed',
      after_label: 'Po'
    });
  }

  // pokaż btn back to homepage kiedy szablony w artykułach sa nieaktywne
  if ($('.article__entry p').length > 0) {
    $(".backToHomepage").addClass('visible');
    $(".wboBelkaCover").addClass('visible');
  }

  // Share post - pokaz
  $("[data-sharePost]").on("click", function (e) {
    e.preventDefault();

    $("[data-overlay]").addClass("showOverlay");
    $(".sharePost__content").addClass("showBox");
  });

  // Share post - ukryj
  $("[data-overlay]").on("click", function (e) {
    e.preventDefault();

    $("[data-overlay]").removeClass("showOverlay");
    $(".sharePost__content").removeClass("showBox");
  });

  $(document).on('keydown', function(e) {
    if (e.keyCode === 27 && $('.sharePost__content').is(':visible')) { 
      $('.sharePost__content').removeClass('showBox');
      $("[data-overlay]").removeClass("showOverlay");
    }
  });

  // kopiowanie adresu url strony
  $("[data-copyLink]").on("click", function (e) {
    e.preventDefault();
    copyUrl();
  });


  function copyUrl() {
    if (!window.getSelection) {
      alert('Skopiuj adres URL z paska adresu.');
      return;
    }
    const dummy = document.createElement('p');
    dummy.textContent = window.location.href;
    document.body.appendChild(dummy); 

    const range = document.createRange();
    range.setStartBefore(dummy);
    range.setEndAfter(dummy);

    const selection = window.getSelection();

    // Wyczyść, na wypadek, gdyby użytkownik wybrał już inny tekst
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand('copy');
    document.body.removeChild(dummy);

    $('[data-change-copy-text]').text('Skopiowano!');
  }

  //progressbar
  if ($('.round').length > 0 ) {
    $('.round').each(function ()  {
      let $round = $(this),
          roundRadius = $round.find('circle').attr('r'),
          roundPercent = $round.data('percent'),
          roundCircum = 2 * roundRadius * Math.PI,
          roundDraw = roundPercent * roundCircum / 100;

      switch (roundPercent) {
        case 100 :
          $round.removeClass('none');
          $round.addClass('full');
          $round.css('stroke-dasharray', roundDraw  + ' 999');
          break
        case 0 :
          $round.addClass('none');
          break
        default :
          $round.removeClass('none');
          $round.css('stroke-dasharray', roundDraw  + ' 999');
      }
    });
  }

  // test kartki /////////////////////////////////////////////////////////////////////
    if ($('#specialCard').length > 0) {
      var clipboard = new ClipboardJS('.copyUrl');
      // console.log(clipboard)
      clipboard.on('success', function(e) {
        $('.copyUrl').text('Skopiowano');
      });
      initCardForm();
    }


    function initCardForm() {
    $('#specialCard .card__photo').click(function() {
      scrollToPage($('#cardPhoto'), 5, 600);

      $('.card__photo').removeClass('active');
      $(this).addClass('active');
      updateCardImage($(this));
      resetData();
    });

    $('#cardText button').click(function() {
    scrollToPage($('#cardText'), 5, 600);

    $('#cardText').find('button').removeClass('active');
    $(this).addClass('active');
    updateCardMessage($(this));
    resetData();
  });

    $('#cardText textarea').keyup(function() {
    $('#cardView .text').text($(this).val());

    $(this).next('.txtMaxLength').children('.currentVal').text($(this).val().length);
  });

    $('#cardAuthor input').keyup(function() {
    $(this).next('.txtMaxLength').children('.currentVal').text($(this).val().length);
  });

    $('#cardAuthor #name').keyup(function() {
    var text = $(this).val();
    if (text === '') {
    text = 'Twój podpis';
  }
    $('#cardView .author').text(text);
    resetData();
  });

    $('#sendCardData').click(function(e) {


      e.preventDefault();

      if (validateForm()) {
        if ($(window).width() > 767) {
          scrollToPage($('#cardView'), 10, 600);
        }

        //Ukrycie buttona, pokazanie loadera
        $(this).hide();
        $('#csv-loader-wrapper').show()

        submitCardForm();
    } else {
      scrollToPage($('#cardText'), 30, 600);
    }

  });
  }

    function updateCardImage($btn) {
    var src = $btn.find('img').prop('src');
    $('#cardView .photo').prop('src', src);
  }

    function updateCardMessage($btn) {
    var text = ($btn.data('type') === 'custom')
    ? $btn.find('textarea').val()
    : $btn.find('p').html();
    $('#cardView .text').html(text);
  }

    function validateForm() {
    var valid = true;
    if (!valdateText()) {
    valid = false;
  }
    if (!valdateName()) {
    valid = false;
  }
    return valid;
  }

    function valdateText() {
    var $btn = $('#cardText button.active');
    if ($btn.data('type') === 'preset') {
    $('#cardText button').removeClass('error');
    return true;
  }
    if ($btn.find('textarea').val() !== '') {
    $('#cardText button').removeClass('error');
    return true;
  }
    $btn.addClass('error');
    return false;
  }

    function valdateName() {
    var $input = $('#cardAuthor #name');
    if ($input.val() === '') {
    $input.addClass('error');
    return false;
  }
    $input.removeClass('error');
    return true;
  }

    function resetData() {
    $('#cardShareBox').fadeOut(100, function() {
      $('#sendCardData').fadeIn();
    });
  }

    function submitCardForm() {
    var imageSrc = $('.cards__result').find('.photo').attr('src');
    var imageSrcNubmer = imageSrc.lastIndexOf('/');
    var imageResult = imageSrc.substring(imageSrcNubmer + 1);

    let data = {
    image: imageResult,
    message: $('.cards__result').find('.text').text(),
    sender: $('.cards__result').find('.author').text(),
    // id: {{ id }}
    id: $('.cards__result').find('.cardId').val(),
    cardset: $('#sendCardData').data('cardset'),
  };

    //console.log(data);

    $.ajax({
    dataType: "json",
    type: "POST",
    //url: 'https:{{ url }}content/send_easter_card',
    url: 'card/generate_card',
    data: data,
    success: function(data) {
    console.log(data);
    if (data.code === '1') {
    $('#sendCardData').fadeOut(100);
    setTimeout(function() {

      //Ukrycie loadera po pomyślnym pobraniu danych
      $('#csv-loader-wrapper').hide()

      $('#cardShareBox').fadeIn(300).find('#urlValue').attr('value', data.msg).val(data.msg);
  },100)

    $('#downloadCard').attr('href', data.download);
  }
  }
  });
  }

    function scrollToPage(el, space ,time) {
    $('html, body').animate({ 
      scrollTop:  el.offset().top - space
    }, time);
  }
});